import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../../authContext/context';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'

// Redux imports
import { useDispatch, useSelector } from 'react-redux';
import { updateGroupCode } from '../../../../redux/slices/groupCodeSlice';

export default function EditGroupCodes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [tagList, setTagList] = React.useState([]);
  const [selectedTags, setSelectedTags] = React.useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const groupCodeList = useSelector((state) => state?.groupCode?.list);
  const groupCodeData = groupCodeList?.find((b) => b._id === id);
  console.log(groupCodeData , 'groupCodeData@123123')

   React.useEffect(() => {
      const fetchTags = async () => {
        try {
          const res = await postRequest('private/fetchTagList', {}, authCtx.token);
          console.log(res , 'Response---0d0idh')
          if (res?.status === 200) {
            setTagList(res?.data || []);
          } else {
            toast.error(res?.message || 'Failed to fetch tags');
          }
        } catch (error) {
          toast.error('Error fetching tags');
        }
      };
      fetchTags();
    }, []);


 
 const onSubmit = async (data) => {
  setLoading(true);
  try {
    const payload = {
      name: data?.name,
      tags: selectedTags, 
    };

    const response = await postRequest(`private/editGroupCode/${id}`, payload, authCtx.token);
    if (response?.status === 200) {
      //toast.success('GroupCode updated successfully!');
      dispatch(updateGroupCode(response?.data));
      reset();
      navigate('/groupcodes');
    } else {
      //toast.error(response?.message || 'Groupcode update failed');
    }
  } catch (err) {
    //toast.error(err?.message || 'Something went wrong');
  } finally {
    setLoading(false);
  }
};

React.useEffect(() => {
  if (groupCodeData) {
    reset({
      name: groupCodeData?.name,
    });
    setSelectedTags(groupCodeData?.tags || []);
  }
}, [groupCodeData, reset]);


  return (
    <>
      <BreadcrumbsWrapper
                                                        items={[
                                                          { label: 'Dashboard', path: '/dashboard' },
                                                          { label: 'GroupCodes', path: '/groupCodes' },
                                                          { label: 'EditGroupCode', path: '' },
                                                        
                                                         
                                                        ]}
                                                      />
                                                <br></br>
      <div className="page-header">
        <h1 className="mt-0">Edit Group Codes</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="title">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Name"
                {...register('name', { required: 'Name is required' })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
  <Form.Group as={Col} controlId="tags">
    <Form.Label>Tags</Form.Label>
    <Form.Control
      as="select"
      multiple
      value={selectedTags}
      onChange={(e) => {
        const selected = Array.from(e.target.selectedOptions, (option) => option.value);
        setSelectedTags(selected);
      }}
    >
      {tagList.map((tag) => (
        <option key={tag._id} value={tag._id}>
          {tag.name}
        </option>
      ))}
    </Form.Control>
  </Form.Group>
</Row>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/groupCodes')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize'
  type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}
